import { Col, Row, Select, message } from 'antd';
import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input, InputNumber } from 'antd';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { addUser, fetchOneUser, updateUser, fetchAllUser } from 'redux/features/user';
import { getUserProfile } from "redux/features/auth";
import { fetchAllWajib } from 'redux/features/wajib_pajak';
import Password from 'antd/lib/input/Password';
import { kabupatens } from 'constants/DataConstant';


const opds =
  [
    { "label": "KEMENKOP", "value": "KEMENKOP" },
  ]

export const USER = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const location = useLocation()

  const [companies, setCompanies] = useState([])
  const [role, setRole] = useState(3)
  const [pmo, setPMO] = useState([]);
  const [ba, setBA] = useState([]);

  const getDataUsers = async (params) => {
    try {
      const profile = await dispatch(getUserProfile()).unwrap();
      setRole(profile.data.user.role_id)
      const bas = await dispatch(fetchAllUser({
        ...params,
        limit: 100,
        role_id: 3,
        kabupaten: profile.data.user.kabupaten,
      })).unwrap()
      const pmos = await dispatch(fetchAllUser({
        ...params,
        limit: 100,
        role_id: 2,
        kabupaten: profile.data.user.kabupaten,
      })).unwrap()
      const transformedBA = bas.data.map(item => ({
        value: item.username,
        label: item.username
      }));
      const transformedPMO = pmos.data.map(item => ({
        value: item.username,
        label: item.username
      }));
      setBA(transformedBA)
      setPMO(transformedPMO)
    } catch (error) {
      message.error(error?.message || 'Failed to fetch data')
    }
  }

  const handleChange = (value) => {
    setRole(value)
  };

  const onFinish = (values) => {
    if (location?.state?.id) {
      updateData(values)
    } else {
      createData(values)
    }
  }

  const createData = async (values) => {
    try {
      await dispatch(addUser({
        ...values,
        role_id: role === 1 ? values.role_id : undefined
      })).unwrap()
      history.push("/app/users")
    } catch (error) {
      message.error(error?.message || 'Failed to register')
    }
  }

  const updateData = async (values) => {
    try {
      await dispatch(updateUser({
        ...values,
        id: location?.state?.id,
        role_id: role === 1 ? values.role_id : undefined
      })).unwrap()
      // history.push("/app/users")
      if(role === 1){
        history.push("/app/my-users")
      }else if(role === 2){
        history.push("/app/my-ba")
      }else{
        history.push("/app/settings")
      }
    } catch (error) {
      message.error(error?.message || 'Failed to fetch data')
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const getDataById = async (id) => {
    try {
      const data = await dispatch(fetchOneUser(id)).unwrap()
      form.setFieldsValue({
        ...data.data
      });
    } catch (err) {
      console.log(err)
    }
  }

  const getAllCompanies = async () => {
    try {
      const { data } = await dispatch(fetchAllWajib({ limit: 100 })).unwrap();
      const list_pt = data.data.map(item => ({
        value: item.perusahaan,
        label: item.perusahaan
      }));

      setCompanies(list_pt);
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getAllCompanies()
    getDataUsers()
    if (location?.state?.id) {
      getDataById(location?.state?.id)
    }
  }, [])

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Tambah/Update Data Pengguna</h2>
          <p>Tolong isikan data sesuai dengan data pengguna</p>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Form
              name="basic"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  {
                    required: true,
                    message: 'Please input your username!',
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: 'Please input your email!',
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="No HP"
                name="no_phone"
              >
                <Input />
              </Form.Item>

              {role === 1 || role === 2 && (
                <>
                  <Form.Item
                    label="PMO"
                    name="id_pmo"
                  >
                    <Select options={pmo} />
                  </Form.Item>
                  
                </>
              )}

              {role === 1 && (
                <>
                  <p style={{ color: "black", fontWeight: "bold" }}>(1.Admin ; 2.PMO ; 3.BA ; 4.Dinas Provinsi ; 5.Dinas Kab/Kota; 6. Verifikator)</p>
                  <Form.Item
                    label="Role"
                    name="role_id"
                  >
                    <Select placeholder="Select Role Number" options={[{ value: 1, label: 1 }, { value: 2, label: 2 }, { value: 3, label: 3 }, { value: 4, label: 4 }, { value: 5, label: 5 }, { value: 6, label: 6 }]} />
                  </Form.Item>
                </>
              )}
              {role === 1 && (
                <Form.Item
                  label="Kabupaten"
                  name="kabupaten"
                  rules={[
                    {
                      required: true,
                      message: 'Please select city!',
                    },
                  ]}
                >
                  <Select options={kabupatens} />
                </Form.Item>
              )}

              {role === 1 && (
                <Form.Item
                  label="OPD"
                  name="opd"

                >
                  <Select options={opds} />
                </Form.Item>
              )}


              {role === 1 && (
                <Form.Item
                  label="Instansi"
                  name="perusahaan"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your company!',
                    },
                  ]}
                >
                  <Select options={companies} />
                </Form.Item>)}

              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Please input password!',
                  },
                ]}
              >
                <Password />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default USER